import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    location: Object,
    showAsset: Boolean
  }

  connect() {
    this.render()
  }

  locationValueChanged() {
    this.render()
  }

  showAssetValueChanged() {
    this.render()
  }

  render() {
    if (!this.locationValue) return

    const location = this.locationValue
    const category = location.category
    
    if (window.locationCardTemplates && window.locationCardTemplates[category]) {
      const customHtml = window.locationCardTemplates[category](location, this.showAssetValue)
      if (customHtml != null) {
        this.element.innerHTML = customHtml
        return
      }
    }

    this.element.innerHTML = this.defaultTemplate(location)
  }

  defaultTemplate(location) {
    const { id, name, category, humanized_category, assets = [], state, state_tag, state_timestamp, kg_asset_name, tvid, location_card_icon } = location
    const iconSvg = location_card_icon || '' 
    const showAsset = this.showAssetValue
    const categoryDisplay = humanized_category || category || 'Location'
    
    let stateHtml = ''

    if(category === 'legacy') {
      if(kg_asset_name) {
        stateHtml = `<div><span class="text-sm font-semibold text-secondary text-end">AssetName: ${kg_asset_name}</span></div>`
      }
      if(tvid) {
        stateHtml = `<div><span class="text-sm font-semibold text-secondary text-end">TVID: ${tvid}</span></div>`
      }
    }else{
      if(state) {
        stateHtml = `<div class="status-bar"><div><span class="tag ${state_tag || ''}-tag">${state}</span></div>${state !== 'Healthy' && state_timestamp ? `<div><span class="timestamp timestamp-${state.toLowerCase()}">Since: ${state_timestamp}</span></div>` : ''}</div>`
      }
    }

    const assetsHtml = showAsset && assets.length > 0 ? `
      <div class="secondry-card">
        <table class="asset-table">
          <tbody>
            ${assets.map(asset => `<tr><td>${asset.asset_type || ''}</td><td></td><td><span class="tag ${asset.state_tag || ''}-tag">${asset.state || ''}</span></td></tr>`).join('')}
          </tbody>
        </table>
      </div>
    ` : ''

    return `
      <div class="sidebar-card sidebar-card-${category || ''}">
        <div class="main-card">
          <a data-turbo="false" href="/location_management/locations/${id}">
            <div class="card-title">
              ${iconSvg || ''}
              <span>${categoryDisplay}</span>
              ${assets.length > 0 ? `<span>(${assets.length} assets)</span>` : ''}
            </div>
            <div class="card-body">
              <h6>${name || ''}</h6>
              ${stateHtml}
            </div>
          </a>
        </div>
        ${assetsHtml}
      </div>
    `
  }
}
